export interface IExchMarketData {
  exchmktId: string | number
  displayName: string
  exchId: string | number
  exchName: string
  exchCode: string
  marketId: string | number
  marketName: string
  baseCurrencyCode: string
  quoteCurrencyCode: string
  baseIsFiat: boolean | string
  quoteIsFiat: boolean | string
  baseCurrencyName: string
  quoteCurrencyName: string
  quantityPrecision: number | string
  pricePrecision: number | string
  last: number | string
  volume24: number | string
  candles: any[] | string
  prevMarketName: string
  prevDisplayName: string
  nextMarketName: string
  nextDisplayName: string
  nextSlug: string
  prevSlug: string
  nextSlugName: string
  prevSlugName: string
}

export class ExchMarketData implements IExchMarketData {
  constructor(
    public exchmktId: string | number = '',
    public displayName: string = '',
    public exchId: string | number = '',
    public exchName: string = '',
    public exchCode: string = '',
    public marketId: string | number = '',
    public marketName: string = '',
    public baseCurrencyCode: string = '',
    public quoteCurrencyCode: string = '',
    public baseIsFiat: boolean | string = '',
    public quoteIsFiat: boolean | string = '',
    public baseCurrencyName: string = '',
    public quoteCurrencyName: string = '',
    public quantityPrecision: number | string = '',
    public pricePrecision: number | string = '',
    public last: number | string = '',
    public volume24: number | string = '',
    public candles: any[] | string = '',
    public prevMarketName: string = '',
    public prevDisplayName: string = '',
    public nextMarketName: string = '',
    public nextDisplayName: string = '',
    public nextSlug: string = '',
    public prevSlug: string = '',
    public nextSlugName: string = '',
    public prevSlugName: string = ''
  ) {}
}

export default ExchMarketData 